import { type IBaseMigrationItemCode } from '../../../interfaces';
import { ItemCodeToNoteMappingHandler } from '../../../mappings/item-code-to-notes';
import {
  CorePracticeItemCode,
  ICorePracticeItemCode,
  ItemCodeSourceEntity,
} from '../../source/entities/item-codes';

export class CorePracticeItemCodeToNoteMappingHandler extends ItemCodeToNoteMappingHandler<
  CorePracticeItemCode,
  ItemCodeSourceEntity
> {
  override sourceEntity = new ItemCodeSourceEntity();
  override translateFn = (
    record: ICorePracticeItemCode
  ): IBaseMigrationItemCode => ({
    ...record,
    description: record.name,
  });
}
